import { render, staticRenderFns } from "./ChatThemeEditor.vue?vue&type=template&id=166a33ba&scoped=true"
import script from "./ChatThemeEditor.vue?vue&type=script&lang=js"
export * from "./ChatThemeEditor.vue?vue&type=script&lang=js"
import style0 from "./ChatThemeEditor.vue?vue&type=style&index=0&id=166a33ba&prod&scoped=true&lang=scss"
import style1 from "./ChatThemeEditor.vue?vue&type=style&index=1&id=166a33ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166a33ba",
  null
  
)

export default component.exports